module.exports = __webpack_public_path__ + "img/08_Lichttechnik-Preis.759a3ffe.svg";